/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';

import PropTypes from 'prop-types';

import styles from './Switch.module.scss';

class Switch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      on: false,
    };
  }

  handleChange = () => {
    const { on } = this.state;
    const { onChange } = this.props;
    this.setState({ on: !on });
    onChange(!on);
  }

  render() {
    const { on } = this.state;
    return (
      <div
        onClick={this.handleChange}
        className={styles.switchWrapper}
      >
        <div className={[
          styles.switchContainer,
          on ? styles.switchContainerActive : null,
        ].join(' ')}
        >
          <div />
        </div>
      </div>
    );
  }
}

Switch.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default Switch;
